import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ts-save-button',
  templateUrl: './ts-save-button.component.html',
  styles: [],
  standalone: false,
})
export class TsSaveButtonComponent implements OnInit {
  @Input() isSaving?: boolean;

  @Output() save = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}
}
